import cn from "classnames";
import BookShow from "components/shared/book/show";
import { GeoPicker } from "components/shared/form";
import Loader from "components/shared/loader";
import { getInitialStateFromConfig, serializeReq } from "helpers/form";
import { requiredField } from "helpers/validators";
import React from "react";
import { CustomScroll } from "react-custom-scroll";
import { customConnect } from "./container";

const config = {
    name: {
        label: "Название",
        inputProps: { name: "name" },
        validators: [requiredField],
        required: true,
    },
    client: {
        label: "Клиент",
        inputProps: { name: "client" },
    },
    geozone: {
        validators: [requiredField],
    },
};

const initialState = getInitialStateFromConfig(config);

class CounterpartyPointForm extends BookShow {
    getItem = ({ source, match }) => {
        const defParams = { isLoading: false, isValid: true, shouldUpdate: false };
        if (match.params.id) {
            source.getItem(match.params).then((data) => this.setState({ data, initial: data, ...defParams }));
        } else {
            this.setState(defParams);
        }
    };

    get dropdActions() {
        const actions = [];
        if (!this.props.canEditBooks) {
            return actions;
        }
        actions.push({ text: "Удалить", action: this.actionClose });

        return actions;
    }

    apply = () => {
        const { source, match, mergeParams, back } = this.props;
        const { isLoading, shouldUpdate, ...state } = this.state;
        if (!isLoading && shouldUpdate) {
            if (this.isValidForm(state.data)) {
                this.setState({ isLoading: true, isValid: true });
                return source.apply(serializeReq({ ...match.params, ...state.data })).then((res) => {
                    if (res) {
                        match.params.id ? this.update(mergeParams) : back();
                    } else {
                        this.setState({ isLoading: false, isValid: false });
                    }
                });
            }
            this.setState({ isValid: false });
        }
    };

    renderButton = () => {
        const { canEditBooks, match, back } = this.props;
        if (!canEditBooks) {
            return null;
        }
        const cname = cn("btn btn-brand btn-sm", { disabled: !this.state.shouldUpdate });
        return (
            <div className="panel__row justify-content-between">
                <div className="btn btn-secondary btn-sm mr-2" onClick={back}>
                    Назад
                </div>
                <div>
                    {match.params.id && (
                        <div className="btn btn-danger btn-sm mr-2" onClick={this.actionClose}>
                            Удалить
                        </div>
                    )}
                    <div className={cname} onClick={this.apply}>
                        {match.params.id ? "Обновить" : "Создать"}
                    </div>
                </div>
            </div>
        );
    };

    render() {
        const { config, switchMap, roles } = this.props;
        if (this.state.isLoading) {
            return <Loader prefix="absolute-center" />;
        }
        const disabled = !(
            roles.isTruckingOrganizationAdmin ||
            roles.isTruckingOrganizationManager ||
            roles.isTruckingOrganizationHeadLogist ||
            roles.isTruckingOrganizationOperator
        );
        return (
            <CustomScroll heightRelativeToParent="100%">
                <div className="container-fluid pb-3">
                    <div className="card card-body">
                        {this.renderField({ ...config.name, disabled })}
                        {this.renderField({ ...config.client, disabled })}
                        <GeoPicker
                            label="Адрес"
                            name="geozone"
                            switchMap={switchMap}
                            onChange={this.setValue}
                            value={this.state.data.geozone}
                            disabled={disabled}
                            validators={[requiredField]}
                        />
                        {this.renderButton()}
                    </div>
                </div>
            </CustomScroll>
        );
    }
}

const ConfiguredShow = (props) => <CounterpartyPointForm {...props} config={config} initialState={initialState} />;

export default customConnect(ConfiguredShow);
